export enum SlackMessageEventType {
  INTRO = 'INTRO',
  DIAL = 'DIAL',
  ALERT = 'ALERT',
  BOOK_MEETING = 'BOOK_MEETING',
  CHAT = 'CHAT',
}

export interface SlackOrgIntegrationData {
  channel: string;
  channelId: string;
  messageEvents: SlackMessageEventType[];
  messageEventChannels?: Partial<
    Record<SlackMessageEventType, { channel: string; channelId: string }>
  >;
}

export interface SlackChannel {
  id: string;
  name: string;
}
